import { useState } from 'react';
import { PrintPreviewDialog } from './print-preview-dialog';

/** Controla o diálogo de pré-visualização. Renderize `dialog` uma vez na página. */
export function usePrintPreview() {
  const [state, setState] = useState<{ title: string; html: string } | null>(null);

  const dialog = (
    <PrintPreviewDialog
      open={!!state}
      title={state?.title ?? ''}
      html={state?.html ?? ''}
      onClose={() => setState(null)}
    />
  );

  return { open: (title: string, html: string) => setState({ title, html }), dialog };
}
